export default [{
    path: 'saasIndex',
    name: '巨志云saas',
    meta: {
        showFooter: true
    },
    component: () => import('../../views/saas/index.vue')
}];
